import { ColorPicker as AntColorPicker } from "antd";
import type { ColorPickerProps as AntColorPickerProps } from "antd";
import type { Color } from "antd/es/color-picker";

interface CustomColorPickerProps extends Omit<AntColorPickerProps, "onChange" | "value"> {
  label?: string;
  error?: string;
  labelClassName?: string;
  value?: string;
  onChange?: (color: string) => void;
}

export function ColorPicker({
  label,
  error,
  labelClassName,
  value,
  onChange,
  ...props
}: CustomColorPickerProps) {
  const handleChange = (_value: Color) => {
    if (onChange) {
      onChange(_value.toHexString());
    }
  };

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className={`text-sm font-medium ${labelClassName || "text-gray-700"}`}>
          {label}
        </label>
      )}
      <div className="flex items-center gap-2">
        <AntColorPicker
          value={value}
          onChange={handleChange}
          {...props}
        />
      </div>
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}
